(() => {
  const cache = new Map();
  const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  class ArtCartComplements extends HTMLElement {
    connectedCallback() {
      void this.load();
      // O tema redesenha a sacola reaproveitando este elemento: o conteúdo some e o `hidden` volta
      // sem novo connectedCallback. Observa e recompõe a partir do cache.
      if (!this.observer) {
        this.observer = new MutationObserver(() => {
          if (this.loading || (this.childElementCount && !this.hidden)) return;
          clearTimeout(this.retimer); this.retimer = setTimeout(() => void this.load(), 50);
        });
      }
      this.observer.observe(this, { childList: true, attributes: true, attributeFilter: ['hidden', 'data-handles'] });
    }
    disconnectedCallback() { this.observer?.disconnect(); clearTimeout(this.retimer); this.dispatchEvent(new Event('disconnected')); }
    async load() {
      if (this.loading) return;
      this.loading = true;
      try { await this.render(0); } finally { setTimeout(() => { this.loading = false; }, 0); }
    }
    async render(attempt = 0) {
      this.hidden = true;
      const handles = (this.dataset.handles || '').split(',').filter(Boolean);
      const excluded = new Set(handles);
      try {
        const groups = await Promise.all(handles.slice(0, 3).map(handle => {
          const key = `${this.dataset.shop}:${handle}`;
          if (!cache.has(key)) {
            const url = new URL(this.dataset.endpoint);
            url.searchParams.set('shop', this.dataset.shop);
            url.searchParams.set('handle', handle);
            cache.set(key, fetch(url).then(async response => {
              if (!response.ok) throw new Error('Suggestions unavailable');
              return (await response.json()).products || [];
            }).catch(error => { cache.delete(key); throw error; }));
          }
          return cache.get(key);
        }));
        if (!this.isConnected) return;
        const seen = new Set();
        const products = groups.flat().filter(product => {
          if (!product.variant_id || !product.image || excluded.has(product.handle) || seen.has(product.handle) || !Number.isFinite(Number(product.price))) return false;
          seen.add(product.handle); return true;
        }).slice(0, 6);
        if (!products.length) return;
        const heading = document.createElement('h3'); heading.textContent = 'Complete seu ambiente';
        const list = document.createElement('div'); list.className = 'art-cart-complements__list';
        const status = document.createElement('p'); status.className = 'art-cart-complements__error'; status.setAttribute('role', 'status');
        products.forEach(product => {
          const row = document.createElement('article'); row.className = 'art-cart-complement';
          const href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}`;
          const imageLink = document.createElement('a'); imageLink.href = href;
          const image = document.createElement('img'); image.src = product.image; image.alt = product.title; image.loading = 'eager'; image.width = 68; image.height = 76; imageLink.append(image);
          const details = document.createElement('div');
          const name = document.createElement('a'); name.href = href; name.className = 'art-cart-complement__name'; name.textContent = product.title;
          const price = document.createElement('span'); price.className = 'art-cart-complement__price'; price.textContent = money.format(Number(product.price)); details.append(name, price);
          const add = document.createElement('button'); add.type = 'button'; add.className = 'btn-outline'; add.title = `Adicionar ${product.title}`; add.setAttribute('aria-label', add.title);
          add.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
          add.addEventListener('click', async () => {
            if (this.busy) return;
            this.busy = true; list.querySelectorAll('button').forEach(button => { button.disabled = true; }); status.textContent = '';
            try {
              const api = window.AxiomStandardStorefront;
              if (!api || !window.Axiom?.cart) throw new Error('Não foi possível adicionar agora. Abra o produto e tente novamente.');
              const result = await api.addLines([{ id: Number(product.variant_id), quantity: 1 }], { target: document.getElementById('cart-drawer'), context: 'cart', source: 'cart-drawer' });
              await window.Axiom.cart.render(result.cart);
              document.getElementById('cart-drawer')?.querySelector('[data-cart-drawer-close]')?.focus({ preventScroll: true });
            } catch (error) { status.textContent = error.message || 'Não foi possível adicionar. Tente novamente.'; }
            finally { this.busy = false; list.querySelectorAll('button').forEach(button => { button.disabled = false; }); }
          });
          row.append(imageLink, details, add); list.append(row);
        });
        const dots = document.createElement('div'); dots.className = 'art-cart-complements__dots';
        const pages = list.children.length;
        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button'); dot.type = 'button'; dot.className = 'art-cart-complements__dot';
          dot.setAttribute('aria-label', `Ver sugestão ${index + 1}`);
          dot.addEventListener('click', () => { stop(); list.scrollTo({ left: list.clientWidth * index, behavior: 'smooth' }); });
          dots.append(dot);
        }
        const syncDots = () => {
          const current = Math.min(pages - 1, Math.round(list.scrollLeft / Math.max(1, list.clientWidth)));
          dots.querySelectorAll('.art-cart-complements__dot').forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        };
        list.addEventListener('scroll', syncDots, { passive: true }); syncDots();
        let timer = null;
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
        const start = () => {
          if (timer || pages < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          timer = setInterval(() => {
            if (!this.isConnected || this.hidden) { stop(); return; }
            const current = Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
            const next = current >= pages - 1 ? 0 : current + 1;
            list.scrollTo({ left: list.clientWidth * next, behavior: 'smooth' });
          }, 4000);
        };
        list.addEventListener('pointerenter', stop); list.addEventListener('pointerleave', start);
        list.addEventListener('touchstart', stop, { passive: true }); list.addEventListener('touchend', start, { passive: true });
        this.addEventListener('disconnected', stop);
        start();
        this.replaceChildren(heading, list, dots, status); this.hidden = false;
      } catch {
        // Falha de rede no celular não pode esconder as sugestões para sempre: tenta de novo.
        if (attempt < 2 && this.isConnected) {
          await new Promise(resolve => setTimeout(resolve, 1500 * (attempt + 1)));
          if (this.isConnected) return this.load(attempt + 1);
        }
        /* Do not invent suggestions when the real catalog is unavailable. */
      }
    }
  }
  if (!customElements.get('art-cart-complements')) customElements.define('art-cart-complements', ArtCartComplements);
  const label = () => { const title = document.querySelector('#cart-drawer [data-cart-title]'); if (title) title.textContent = 'Sua sacola'; };
  document.addEventListener('cart:drawer:rendered', label);
  document.addEventListener('theme:cart-drawer:open', label);
  label();
})();